import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { NetworkUser } from './hooks/use-network';

interface TeamBreadcrumbProps {
  navigationHistory: string[];
  visitedUsers: NetworkUser[];
  onNavigate: (memberId: string | null, index: number) => void;
}

const TeamBreadcrumb: React.FC<TeamBreadcrumbProps> = ({ 
  navigationHistory, 
  visitedUsers,
  onNavigate 
}) => {
  // Function to get visited user by ID
  const getVisitedUserById = (id: string): NetworkUser | undefined => {
    return visitedUsers.find(user => user.id === id);
  };

  return (
    <Breadcrumb className="breadcrumb-page-list mb-0 lh-1">
      {navigationHistory.length > 0 && (
        <Breadcrumb.Item 
          onClick={() => onNavigate(null, -1)}
          linkProps={{ className: 'cursor-pointer' }}
          active={false}
        >
          <div className="d-flex align-items-center">
            <i className="ri-team-line me-1 text-primary"></i>
            <span className="text-primary">Inicio</span>
          </div>
        </Breadcrumb.Item>
      )}

      {navigationHistory.map((memberId, index) => {
        const user = getVisitedUserById(memberId);
        const isActive = index === navigationHistory.length - 1;
        
        return (
          <Breadcrumb.Item
            key={memberId}
            onClick={() => onNavigate(memberId, index)}
            linkProps={{ className: 'cursor-pointer' }}
            active={isActive}
          >
            <div className="d-flex align-items-center">
              <span className={!isActive ? 'text-primary' : 'text-white'}>{user?.name || 'Usuario'} ({user?.networkLevel || ''})</span>
            </div>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default TeamBreadcrumb;
